import api from '../factory/AxiosInstance'
import { AppSettings } from '../config/index'
import { CapiRequest } from 'models/request/Index';

const CAPI_MIGRATE_URL = 'CAPI_MIGRATE_URL';
const CAPI_MIGRATE_KEY = 'CAPI_MIGRATE_KEY';

export const migrateToCapi = async (request: CapiRequest) : Promise<string> => {
  const authorization = await AppSettings.get(CAPI_MIGRATE_KEY);
  const fullUrl = `${await AppSettings.get(CAPI_MIGRATE_URL)}?code=${authorization}`;
  const { data } = await api.post(fullUrl, request);
  return data;
}